<template>
  <div class="col-10 col-md-7 col-lg-4 d-flex align-items-stretch">
    <div class="card blog__item overflow-hidden">
			<div class="card-image">
				<a :href="guid" target="_blank">
					<img class="img-fluid" :src="featuredImageUrl" />
				</a>
			</div>
			<div class="card-body">
				<div class="row align-items-center mb-4">
					<div class="col-12">
						<a :href="guid">
							<h5>{{ title }}</h5>
						</a>
					</div>
					<div class="col-12">
						<span class="text-muted">
							{{ formattedDate }}
						</span>
					</div>
				</div>
				<div class="card-info">
					<p>{{ formattedDescription }}</p>
				</div>
				<a :href="guid" target="_blank" class="text-secondary">Read More</a>
			</div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "featuredImageUrl",
    "title",
    "formattedDate",
    "formattedDescription",
    "guid",
  ],
};
</script>